import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
    }
}

let echoInstance: Echo<'reverb'> | null = null;

function parsePort(value: string | undefined, fallback: number): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}

/** Lazily initialize and reuse the Reverb/Echo singleton. */
export function getEcho(): Echo<'reverb'> | null {
    if (typeof window === 'undefined') {
        return null;
    }

    if (echoInstance) {
        return echoInstance;
    }

    const key = import.meta.env.VITE_REVERB_APP_KEY as string | undefined;
    if (!key) {
        return null;
    }

    window.Pusher = Pusher;

    echoInstance = new Echo({
        broadcaster: 'reverb',
        key,
        wsHost: (import.meta.env.VITE_REVERB_HOST as string | undefined) || window.location.hostname,
        wsPort: parsePort(import.meta.env.VITE_REVERB_PORT as string | undefined, 80),
        wssPort: parsePort(import.meta.env.VITE_REVERB_PORT as string | undefined, 443),
        forceTLS: ((import.meta.env.VITE_REVERB_SCHEME as string | undefined) || 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    });

    return echoInstance;
}
